// import React, { useEffect, useRef, useState } from "react";
// import {
//   Box,
//   Button,
//   Typography,
//   Card,
//   CardContent,
//   IconButton,
// } from "@mui/material";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import { API_BASE_URL } from "../../config";
// import { LoadingSpinner } from "../../Components/spinner/spinner";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";

// export const Case = () => {
//   const { t } = useTranslation();
//   const scrollContainerRef = useRef(null);
//   const [cases, setCases] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Snackbar state
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("info");

//   useEffect(() => {
//     const fetchCases = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.get(
//           `${API_BASE_URL}/home-notification/fe/`
//         );
//         const data = response.data;
//         if (Array.isArray(data) && data.length > 0) {
//           setCases(data);
//           setSnackbarMessage("Cases loaded successfully.");
//           setSnackbarSeverity("success");
//         } else {
//           setCases([]);
//           // setSnackbarMessage("No cases found.");
//           // setSnackbarSeverity("info");
//         }
//       } catch (error) {
//         console.error("Error fetching cases:", error);
//         setCases([]);
//         // setSnackbarMessage("Failed to load cases.");
//         // setSnackbarSeverity("error");
//       } finally {
//         // setSnackbarOpen(true);
//         setLoading(false);
//       }
//     };

//     fetchCases();
//   }, []);

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const scrollLeft = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({ left: -250, behavior: "smooth" });
//     }
//   };

//   const scrollRight = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({ left: 250, behavior: "smooth" });
//     }
//   };

//   return (
//     <Box sx={{ p: { xs: 1, sm: 3 } }}>
//       {/* Centered Heading */}
//       <Box sx={{ textAlign: "center", mb: { xs: 1, sm: 2 } }}>
//         <Typography
//           variant="h5"
//           fontWeight="bold"
//           sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}
//         >
//           {t("currentCases")}
//         </Typography>
//       </Box>

//       <Box sx={{ display: "flex", alignItems: "center" }}>
//         {/* Left Scroll Button */}
//         <IconButton
//           onClick={scrollLeft}
//           aria-label={t("scrollLeft")}
//           sx={{
//             color: "primary.main",
//             fontWeight: "bold",
//             fontSize: { xs: 24, sm: 32 },
//             border: "1.5px solid",
//             borderColor: "primary.main",
//             bgcolor: "background.paper",
//             "&:hover": { bgcolor: "primary.light" },
//             mr: { xs: 0.5, sm: 1 },
//             p: { xs: 0.5, sm: 1 },
//           }}
//         >
//           <ChevronLeftIcon fontSize="inherit" sx={{ fontWeight: "bold" }} />
//         </IconButton>

//         {/* Scrollable Cards Container */}
//         <Box
//           ref={scrollContainerRef}
//           sx={{
//             display: "flex",
//             overflowX: "auto",
//             scrollBehavior: "smooth",
//             gap: { xs: 1, sm: 2 },
//             flexGrow: 1,
//             "&::-webkit-scrollbar": { display: "none" },
//             scrollbarWidth: "none",
//             minHeight: "120px",
//             justifyContent: cases.length === 0 ? "center" : "flex-start",
//             alignItems: "center",
//           }}
//           tabIndex={0}
//           aria-label={t("casesScrollContainer")}
//         >
//           {loading ? (
//             <LoadingSpinner size={30} height="80px" />
//           ) : cases.length === 0 ? (
//             <Typography
//               variant="body1"
//               color="textSecondary"
//               sx={{ fontWeight: "bold", color: "red" }}
//             >
//               No Data Found
//             </Typography>
//           ) : (
//             cases.map((item) => (
//               <Card
//                 key={item.id}
//                 sx={{
//                   minWidth: { xs: 140, sm: 200 },
//                   flexShrink: 0,
//                   cursor: "pointer",
//                   boxShadow: 3,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   "&:hover": { boxShadow: 6 },
//                   mb: 1,
//                   ml: 1,
//                 }}
//                 onClick={() =>
//                   window.open(item.link, "_blank", "noopener")
//                 }
//                 role="button"
//                 tabIndex={0}
//                 aria-label={`${t("case")}: ${item.name_of_fe}`}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter" || e.key === " ") {
//                     window.open(item.link, "_blank", "noopener");
//                   }
//                 }}
//               >
//                 <CardContent>
//                   <Typography
//                     variant="subtitle1"
//                     fontWeight="bold"
//                     noWrap
//                     textAlign="center"
//                     sx={{ fontSize: { xs: "0.85rem", sm: "1rem" } }}
//                   >
//                     {item.name_of_fe}
//                   </Typography>
//                 </CardContent>
//               </Card>
//             ))
//           )}
//         </Box>

//         {/* Right Scroll Button */}
//         <IconButton
//           onClick={scrollRight}
//           aria-label={t("scrollRight")}
//           sx={{
//             color: "primary.main",
//             fontWeight: "bold",
//             fontSize: { xs: 24, sm: 32 },
//             border: "1.5px solid",
//             borderColor: "primary.main",
//             bgcolor: "background.paper",
//             "&:hover": { bgcolor: "primary.light" },
//             ml: { xs: 0.5, sm: 1 },
//             p: { xs: 0.5, sm: 1 },
//             mb: 1,
//           }}
//         >
//           <ChevronRightIcon fontSize="inherit" sx={{ fontWeight: "bold" }} />
//         </IconButton>
//       </Box>

//       {/* Explore All Cases Button */}
//       <Box mt={3} textAlign="center">
//         <Button
//           variant="contained"
//           color="primary"
//           component={Link}
//           to="/financial-establishments"
//           sx={{
//             minWidth: { xs: 150, sm: 200 },
//             fontSize: { xs: "0.85rem", sm: "1rem" },
//             px: { xs: 2, sm: 3 },
//             py: { xs: 1, sm: 1.5 },
//           }}
//         >
//           {t("exploreAllCases")}
//         </Button>
//       </Box>

//       {/* Snackbar */}
//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };


// import React, { useEffect, useRef, useState } from "react";
// import {
//   Box,
//   Button,
//   Typography,
//   Card,
//   CardContent,
//   IconButton,
//   Fade,
//   Grow,
//   Slide,
//   useTheme,
//   useMediaQuery
// } from "@mui/material";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import GavelIcon from "@mui/icons-material/Gavel";
// import ExploreIcon from "@mui/icons-material/Explore";
// import { API_BASE_URL } from "../../config";
// import { LoadingSpinner } from "../../Components/spinner/spinner";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import i18next from "i18next";

// export const Case = () => {
//   const { t } = useTranslation();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const scrollContainerRef = useRef(null);
//   const [cases, setCases] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [autoScroll, setAutoScroll] = useState(true);
//   const [visibleCards, setVisibleCards] = useState(new Set());

//   // Snackbar state
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("info");

//   useEffect(() => {
//     const fetchCases = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.get(
//           // `${API_BASE_URL}/home-notification/fe/`
//           `${API_BASE_URL}/home-notification/assignedfe/`, {params: { language: i18next.language }}
//         );
//         const data = response.data; 
//         if (Array.isArray(data) && data.length > 0) {
//           setCases(data);
//         } else {
//           setCases([]);
//         }
//       } catch (error) {
//         console.error("Error fetching cases:", error);
//         setCases([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCases();
//   }, []);

  

//   // Auto-scroll functionality
//   useEffect(() => {
//     if (!autoScroll || cases.length === 0 || loading) return;

//     const interval = setInterval(() => {
//       if (scrollContainerRef.current) {
//         const container = scrollContainerRef.current;
//         const scrollWidth = container.scrollWidth;
//         const clientWidth = container.clientWidth;
//         const currentScroll = container.scrollLeft;
        
//         if (currentScroll + clientWidth >= scrollWidth - 10) {
//           // If at the end, scroll back to start
//           container.scrollTo({ left: 0, behavior: 'smooth' });
//         } else {
//           // Scroll right
//           container.scrollBy({ left: 250, behavior: 'smooth' });
//         }
//       }
//     }, 2500); // Scroll every 3 seconds

//     return () => clearInterval(interval);
//   }, [autoScroll, cases.length, loading]);

//   // Intersection Observer for card animations
//   useEffect(() => {
//     if (!scrollContainerRef.current || cases.length === 0) return;

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setVisibleCards(prev => new Set(prev).add(entry.target.dataset.index));
//           }
//         });
//       },
//       {
//         root: scrollContainerRef.current,
//         threshold: 0.3,
//         rootMargin: '50px'
//       }
//     );

//     const cards = scrollContainerRef.current.querySelectorAll('.case-card');
//     cards.forEach((card, index) => {
//       card.dataset.index = index;
//       observer.observe(card);
//     });

//     return () => observer.disconnect();
//   }, [cases]);

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const scrollLeft = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({ left: -300, behavior: "smooth" });
//     }
//   };

//   const scrollRight = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({ left: 300, behavior: "smooth" });
//     }
//   };

//   const handleContainerHover = (isHovering) => {
//     setAutoScroll(!isHovering);
//   };

//   return (
//     <Box 
//       sx={{ 
//         p: { xs: 2, sm: 4 },
//         background: "linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%)",
//         borderRadius: 4,
//         mx: { xs: 1, sm: 2 },
//         mt: 2,
//         position: "relative",
//         overflow: "hidden",
//         '&::before': {
//           content: '""',
//           position: 'absolute',
//           top: -50,
//           right: -50,
//           width: 100,
//           height: 100,
//           borderRadius: '50%',
//           background: 'rgba(66, 133, 244, 0.1)',
//           animation: 'float 8s ease-in-out infinite',
//         },
//         '&::after': {
//           content: '""',
//           position: 'absolute',
//           bottom: -30,
//           left: '10%',
//           width: 60,
//           height: 60,
//           borderRadius: '50%',
//           background: 'rgba(234, 67, 53, 0.08)',
//           animation: 'float 6s ease-in-out infinite 2s',
//         }
//       }}
//     >
//       {/* Centered Heading with Icon */}
//       <Fade in={!loading} timeout={800}>
//         <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4 } }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 1 }}>
//             <GavelIcon 
//               sx={{ 
//                 fontSize: { xs: 32, sm: 40 },
//                 color: 'primary.main',
//                 animation: 'bounce 2s ease-in-out infinite'
//               }} 
//             />
//             <Typography
//               variant="h4"
//               fontWeight="bold"
//               sx={{ 
//                 fontSize: { xs: "1.5rem", sm: "2rem" },
//                 background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//               }}
//             >
//               {t("currentCases")}
//             </Typography>
//           </Box>
//           <Typography
//             variant="body1"
//             color="text.secondary"
//             sx={{ fontSize: { xs: "0.9rem", sm: "1.1rem" } }}
//           >
//             Browse through ongoing financial establishment cases
//           </Typography>
//         </Box>
//       </Fade>

//       <Box sx={{ display: "flex", alignItems: "center", position: "relative" }}>
//         {/* Left Scroll Button */}
//         <Slide direction="right" in={!loading} timeout={500}>
//           <IconButton
//             onClick={scrollLeft}
//             aria-label={t("scrollLeft")}
//             sx={{
//               color: "white",
//               fontWeight: "bold",
//               fontSize: { xs: 20, sm: 28 },
//               background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//               border: "2px solid",
//               borderColor: "primary.main",
//               "&:hover": { 
//                 background: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)',
//                 transform: "scale(1.1)",
//               },
//               mr: { xs: 1, sm: 2 },
//               p: { xs: 1, sm: 1.5 },
//               transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//               boxShadow: "0 4px 15px rgba(25, 118, 210, 0.3)",
//               zIndex: 2,
//             }}
//           >
//             <ChevronLeftIcon fontSize="inherit" />
//           </IconButton>
//         </Slide>

//         {/* Scrollable Cards Container */}
//         <Box
//           ref={scrollContainerRef}
//           onMouseEnter={() => handleContainerHover(true)}
//           onMouseLeave={() => handleContainerHover(false)}
//           sx={{
//             display: "flex",
//             overflowX: "auto",
//             scrollBehavior: "smooth",
//             gap: { xs: 2, sm: 3 },
//             flexGrow: 1,
//             "&::-webkit-scrollbar": { 
//               height: 6,
//             },
//             "&::-webkit-scrollbar-track": {
//               background: 'rgba(0,0,0,0.1)',
//               borderRadius: 3,
//             },
//             "&::-webkit-scrollbar-thumb": {
//               background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//               borderRadius: 3,
//             },
//             scrollbarWidth: "thin",
//             minHeight: "160px",
//             justifyContent: cases.length === 0 ? "center" : "flex-start",
//             alignItems: "center",
//             py: 2,
//             px: 1,
//           }}
//           tabIndex={0}
//           aria-label={t("casesScrollContainer")}
//         >
//           {loading ? (
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//               <LoadingSpinner size={40} color="primary" />
//               <Typography variant="body1" color="text.secondary">
//                 Loading cases...
//               </Typography>
//             </Box>
//           ) : cases.length === 0 ? (
//             <Fade in={!loading} timeout={800}>
//               <Box sx={{ textAlign: 'center', py: 4 }}>
//                 <Typography
//                   variant="h6"
//                   color="textSecondary"
//                   sx={{ 
//                     fontWeight: "bold", 
//                     color: "#666",
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1
//                   }}
//                 >
//                   <span style={{ fontSize: '1.5rem' }}>📭</span>
//                   No Cases Available
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                   Check back later for new cases
//                 </Typography>
//               </Box>
//             </Fade>
//           ) : (
//             cases.map((item, index) => (
//               <Grow 
//                 in={visibleCards.has(index.toString())} 
//                 timeout={800 + (index * 100)}
//                 key={item.id}
//               >
//                 <Card
//                   className="case-card"
//                   sx={{
//                     minWidth: { xs: 200, sm: 240 },
//                     flexShrink: 0,
//                     cursor: "pointer",
//                     background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
//                     border: "2px solid transparent",
//                     boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
//                     transform: "translateY(0)",
//                     mb: 1,
//                     ml: 1,
//                     position: "relative",
//                     overflow: "hidden",
//                     '&::before': {
//                       content: '""',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       right: 0,
//                       height: '4px',
//                       background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//                       transform: 'scaleX(0)',
//                       transition: 'transform 0.3s ease',
//                     },
//                     '&:hover': { 
//                       transform: "translateY(-8px) scale(1.02)",
//                       boxShadow: "0 15px 40px rgba(25, 118, 210, 0.25)",
//                       borderColor: "primary.main",
//                       '&::before': {
//                         transform: 'scaleX(1)',
//                       }
//                     },
//                   }}
//                   onClick={() => window.open(item.link, "_blank", "noopener")}
//                   role="button"
//                   tabIndex={0}
//                   aria-label={`${t("case")}: ${item.name_of_fe}`}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter" || e.key === " ") {
//                       window.open(item.link, "_blank", "noopener");
//                     }
//                   }}
//                 >
//                   <CardContent sx={{ p: 3, textAlign: 'center', width: '100%' }}>
//                     <Box
//                       sx={{
//                         width: 50,
//                         height: 50,
//                         background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//                         borderRadius: '50%',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         margin: '0 auto 12px',
//                         color: 'white',
//                         fontSize: '1.5rem',
//                         boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
//                       }}
//                     >
//                       ⚖️
//                     </Box>
//                     <Typography
//                       variant="h6"
//                       fontWeight="bold"
//                       noWrap
//                       sx={{ 
//                         fontSize: { xs: "1rem", sm: "1.1rem" },
//                         color: '#333',
//                         lineHeight: 1.3,
//                         mb: 1,
//                       }}
//                     >
//                       {item.name_of_fe}
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       color="text.secondary"
//                       sx={{
//                         fontSize: "0.8rem",
//                         opacity: 0.8,
//                       }}
//                     >
//                       Click to view details
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grow>
//             ))
//           )}
//         </Box>

//         {/* Right Scroll Button */}
//         <Slide direction="left" in={!loading} timeout={500}>
//           <IconButton
//             onClick={scrollRight}
//             aria-label={t("scrollRight")}
//             sx={{
//               color: "white",
//               fontWeight: "bold",
//               fontSize: { xs: 20, sm: 28 },
//               background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//               border: "2px solid",
//               borderColor: "primary.main",
//               "&:hover": { 
//                 background: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)',
//                 transform: "scale(1.1)",
//               },
//               ml: { xs: 1, sm: 2 },
//               p: { xs: 1, sm: 1.5 },
//               transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//               boxShadow: "0 4px 15px rgba(25, 118, 210, 0.3)",
//               zIndex: 2,
//             }}
//           >
//             <ChevronRightIcon fontSize="inherit" />
//           </IconButton>
//         </Slide>
//       </Box>

//       {/* Explore All Cases Button */}
//       <Fade in={!loading} timeout={1000}>
//         <Box mt={4} textAlign="center">
//           <Button
//             variant="contained"
//             color="primary"
//             component={Link}
//             to="/ca/authority/assingnedfe"
//             startIcon={<ExploreIcon />}
//             sx={{
//               minWidth: { xs: 180, sm: 220 },
//               fontSize: { xs: "0.9rem", sm: "1rem" },
//               px: { xs: 3, sm: 4 },
//               py: { xs: 1.2, sm: 1.5 },
//               background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//               borderRadius: 3,
//               fontWeight: 'bold',
//               textTransform: 'none',
//               boxShadow: '0 8px 25px rgba(25, 118, 210, 0.3)',
//               transition: 'all 0.3s ease',
//               '&:hover': {
//                 background: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)',
//                 transform: 'translateY(-2px)',
//                 boxShadow: '0 12px 35px rgba(25, 118, 210, 0.4)',
//               }
//             }}
//           >
//             {t("exploreAllCases")}
//           </Button>
//         </Box>
//       </Fade>

//       {/* Global styles for animations */}
//       <style jsx global>{`
//         @keyframes float {
//           0%, 100% { transform: translateY(0px) rotate(0deg); }
//           50% { transform: translateY(-10px) rotate(180deg); }
//         }
        
//         @keyframes bounce {
//           0%, 100% { transform: translateY(0); }
//           50% { transform: translateY(-5px); }
//         }
//       `}</style>

//       {/* Snackbar */}
//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };
















// pre final version
// import React, { useEffect, useRef, useState, useCallback } from "react";
// import {
//   Box,
//   Button,
//   Typography,
//   Card,
//   CardContent,
//   IconButton,
//   Fade,
//   Grow,
//   Slide,
//   useTheme,
//   useMediaQuery
// } from "@mui/material";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import GavelIcon from "@mui/icons-material/Gavel";
// import ExploreIcon from "@mui/icons-material/Explore";
// import { API_BASE_URL } from "../../config";
// import { LoadingSpinner } from "../../Components/spinner/spinner";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import i18next from "i18next";

// export const Case = () => {
//   const { t, i18n } = useTranslation();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const scrollContainerRef = useRef(null);
//   const [cases, setCases] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [autoScroll, setAutoScroll] = useState(true);
//   const [visibleCards, setVisibleCards] = useState(new Set());

//   // Snackbar state
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("info");

//   // ✅ FIXED: Fetch cases with language dependency
//   const fetchCases = useCallback(async () => {
//     setLoading(true);
//     try {
//       // console.log('Fetching cases with language:', i18n.language); // Debug log
//       const response = await axios.get(
//         `${API_BASE_URL}/home-notification/assignedfe/`, 
//         { params: { language: i18n.language} }
//       );
//       const data = response.data; 
//       if (Array.isArray(data) && data.length > 0) {
//         setCases(data);
//       } else {
//         setCases([]);
//       }
//     } catch (error) {
//       console.error("Error fetching cases:", error);
//       setCases([]);
//       setSnackbarMessage("Failed to load cases");
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   }, [i18n.language]);

//   // ✅ FIXED: Runs fetchCases whenever language changes
//   useEffect(() => {
//     fetchCases();
//   }, [fetchCases]);

//   // Auto-scroll functionality
//   useEffect(() => {
//     if (!autoScroll || cases.length === 0 || loading) return;

//     const interval = setInterval(() => {
//       if (scrollContainerRef.current) {
//         const container = scrollContainerRef.current;
//         const scrollWidth = container.scrollWidth;
//         const clientWidth = container.clientWidth;
//         const currentScroll = container.scrollLeft;
        
//         if (currentScroll + clientWidth >= scrollWidth - 10) {
//           // If at the end, scroll back to start
//           container.scrollTo({ left: 0, behavior: 'smooth' });
//         } else {
//           // Scroll right
//           container.scrollBy({ left: 250, behavior: 'smooth' });
//         }
//       }
//     }, 2500); // Scroll every 3 seconds

//     return () => clearInterval(interval);
//   }, [autoScroll, cases.length, loading]);

//   // Intersection Observer for card animations
//   useEffect(() => {
//     if (!scrollContainerRef.current || cases.length === 0) return;

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setVisibleCards(prev => new Set(prev).add(entry.target.dataset.index));
//           }
//         });
//       },
//       {
//         root: scrollContainerRef.current,
//         threshold: 0.3,
//         rootMargin: '50px'
//       }
//     );

//     const cards = scrollContainerRef.current.querySelectorAll('.case-card');
//     cards.forEach((card, index) => {
//       card.dataset.index = index;
//       observer.observe(card);
//     });

//     return () => observer.disconnect();
//   }, [cases]);

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const scrollLeft = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({ left: -300, behavior: "smooth" });
//     }
//   };

//   const scrollRight = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({ left: 300, behavior: "smooth" });
//     }
//   };

//   const handleContainerHover = (isHovering) => {
//     setAutoScroll(!isHovering);
//   };

//   if (loading && cases.length === 0) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
//         <LoadingSpinner size={40} />
//       </Box>
//     );
//   }

//   return (
//     <Box 
//       sx={{ 
//         p: { xs: 2, sm: 4 },
//         background: "linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%)",
//         borderRadius: 4,
//         mx: { xs: 1, sm: 2 },
//         mt: 2,
//         position: "relative",
//         overflow: "hidden",
//         '&::before': {
//           content: '""',
//           position: 'absolute',
//           top: -50,
//           right: -50,
//           width: 100,
//           height: 100,
//           borderRadius: '50%',
//           background: 'rgba(66, 133, 244, 0.1)',
//           animation: 'float 8s ease-in-out infinite',
//         },
//         '&::after': {
//           content: '""',
//           position: 'absolute',
//           bottom: -30,
//           left: '10%',
//           width: 60,
//           height: 60,
//           borderRadius: '50%',
//           background: 'rgba(234, 67, 53, 0.08)',
//           animation: 'float 6s ease-in-out infinite 2s',
//         }
//       }}
//     >
//       {/* Centered Heading with Icon */}
//       <Fade in={!loading} timeout={800}>
//         <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4 } }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 1 }}>
//             <GavelIcon 
//               sx={{ 
//                 fontSize: { xs: 32, sm: 40 },
//                 color: 'primary.main',
//                 animation: 'bounce 2s ease-in-out infinite'
//               }} 
//             />
//             <Typography
//               variant="h4"
//               fontWeight="bold"
//               sx={{ 
//                 fontSize: { xs: "1.5rem", sm: "2rem" },
//                 background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//               }}
//             >
//               {t("currentCases")}
//             </Typography>
//           </Box>
//           <Typography
//             variant="body1"
//             color="text.secondary"
//             sx={{ fontSize: { xs: "0.9rem", sm: "1.1rem" } }}
//           >
//             Browse through ongoing financial establishment cases
//           </Typography>
//         </Box>
//       </Fade>

//       <Box sx={{ display: "flex", alignItems: "center", position: "relative" }}>
//         {/* Left Scroll Button */}
//         <Slide direction="right" in={!loading} timeout={500}>
//           <IconButton
//             onClick={scrollLeft}
//             aria-label={t("scrollLeft")}
//             sx={{
//               color: "white",
//               fontWeight: "bold",
//               fontSize: { xs: 20, sm: 28 },
//               background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//               border: "2px solid",
//               borderColor: "primary.main",
//               "&:hover": { 
//                 background: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)',
//                 transform: "scale(1.1)",
//               },
//               mr: { xs: 1, sm: 2 },
//               p: { xs: 1, sm: 1.5 },
//               transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//               boxShadow: "0 4px 15px rgba(25, 118, 210, 0.3)",
//               zIndex: 2,
//             }}
//           >
//             <ChevronLeftIcon fontSize="inherit" />
//           </IconButton>
//         </Slide>

//         {/* Scrollable Cards Container */}
//         <Box
//           ref={scrollContainerRef}
//           onMouseEnter={() => handleContainerHover(true)}
//           onMouseLeave={() => handleContainerHover(false)}
//           sx={{
//             display: "flex",
//             overflowX: "auto",
//             scrollBehavior: "smooth",
//             gap: { xs: 2, sm: 3 },
//             flexGrow: 1,
//             "&::-webkit-scrollbar": { 
//               height: 6,
//             },
//             "&::-webkit-scrollbar-track": {
//               background: 'rgba(0,0,0,0.1)',
//               borderRadius: 3,
//             },
//             "&::-webkit-scrollbar-thumb": {
//               background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//               borderRadius: 3,
//             },
//             scrollbarWidth: "thin",
//             minHeight: "160px",
//             justifyContent: cases.length === 0 ? "center" : "flex-start",
//             alignItems: "center",
//             py: 2,
//             px: 1,
//           }}
//           tabIndex={0}
//           aria-label={t("casesScrollContainer")}
//         >
//           {loading && cases.length === 0 ? (
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//               <LoadingSpinner size={40} color="primary" />
//               <Typography variant="body1" color="text.secondary">
//                 Loading cases...
//               </Typography>
//             </Box>
//           ) : cases.length === 0 ? (
//             <Fade in={!loading} timeout={800}>
//               <Box sx={{ textAlign: 'center', py: 4 }}>
//                 <Typography
//                   variant="h6"
//                   color="textSecondary"
//                   sx={{ 
//                     fontWeight: "bold", 
//                     color: "#666",
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1
//                   }}
//                 >
//                   <span style={{ fontSize: '1.5rem' }}>📭</span>
//                   No Cases Available
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                   Check back later for new cases
//                 </Typography>
//               </Box>
//             </Fade>
//           ) : (
//             cases.map((item, index) => (
//               <Grow 
//                 in={visibleCards.has(index.toString())} 
//                 timeout={800 + (index * 100)}
//                 key={item.id || index}
//               >
//                 <Card
//                   className="case-card"
//                   sx={{
//                     minWidth: { xs: 200, sm: 240 },
//                     flexShrink: 0,
//                     cursor: "pointer",
//                     background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
//                     border: "2px solid transparent",
//                     boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
//                     transform: "translateY(0)",
//                     mb: 1,
//                     ml: 1,
//                     position: "relative",
//                     overflow: "hidden",
//                     '&::before': {
//                       content: '""',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       right: 0,
//                       height: '4px',
//                       background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//                       transform: 'scaleX(0)',
//                       transition: 'transform 0.3s ease',
//                     },
//                     '&:hover': { 
//                       transform: "translateY(-8px) scale(1.02)",
//                       boxShadow: "0 15px 40px rgba(25, 118, 210, 0.25)",
//                       borderColor: "primary.main",
//                       '&::before': {
//                         transform: 'scaleX(1)',
//                       }
//                     },
//                   }}
//                   onClick={() => item.link && window.open(item.link, "_blank", "noopener,noreferrer")}
//                   role="button"
//                   tabIndex={0}
//                   aria-label={`${t("case")}: ${item.name_of_fe}`}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter" || e.key === " ") {
//                       e.preventDefault();
//                       item.link && window.open(item.link, "_blank", "noopener,noreferrer");
//                     }
//                   }}
//                 >
//                   <CardContent sx={{ p: 3, textAlign: 'center', width: '100%' }}>
//                     {/* <Box
//                       sx={{
//                         width: 50,
//                         height: 50,
//                         background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//                         borderRadius: '50%',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         margin: '0 auto 12px',
//                         color: 'white',
//                         fontSize: '1.5rem',
//                         boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
//                       }}
//                     >
//                       ⚖️
//                     </Box> */}
//                     <Typography
//                       variant="h6"
//                       fontWeight="bold"
//                       noWrap
//                       sx={{ 
//                         fontSize: { xs: "1rem", sm: "1.1rem" },
//                         color: '#333',
//                         lineHeight: 1.3,
//                         mb: 1,
//                       }}
//                     >
//                       {item.name_of_fe}
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       color="text.secondary"
//                       sx={{
//                         fontSize: "0.8rem",
//                         opacity: 0.8,
//                       }}
//                     >
//                       Click to view details
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grow>
//             ))
//           )}
//         </Box>

//         {/* Right Scroll Button */}
//         <Slide direction="left" in={!loading} timeout={500}>
//           <IconButton
//             onClick={scrollRight}
//             aria-label={t("scrollRight")}
//             sx={{
//               color: "white",
//               fontWeight: "bold",
//               fontSize: { xs: 20, sm: 28 },
//               background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//               border: "2px solid",
//               borderColor: "primary.main",
//               "&:hover": { 
//                 background: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)',
//                 transform: "scale(1.1)",
//               },
//               ml: { xs: 1, sm: 2 },
//               p: { xs: 1, sm: 1.5 },
//               transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//               boxShadow: "0 4px 15px rgba(25, 118, 210, 0.3)",
//               zIndex: 2,
//             }}
//           >
//             <ChevronRightIcon fontSize="inherit" />
//           </IconButton>
//         </Slide>
//       </Box>

//       {/* Explore All Cases Button */}
//       <Fade in={!loading} timeout={1000}>
//         <Box mt={4} textAlign="center">
//           <Button
//             variant="contained"
//             color="primary"
//             component={Link}
//             to="/ca/authority/assingnedfe"
//             startIcon={<ExploreIcon />}
//             sx={{
//               minWidth: { xs: 180, sm: 220 },
//               fontSize: { xs: "0.9rem", sm: "1rem" },
//               px: { xs: 3, sm: 4 },
//               py: { xs: 1.2, sm: 1.5 },
//               background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//               borderRadius: 3,
//               fontWeight: 'bold',
//               textTransform: 'none',
//               boxShadow: '0 8px 25px rgba(25, 118, 210, 0.3)',
//               transition: 'all 0.3s ease',
//               '&:hover': {
//                 background: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)',
//                 transform: 'translateY(-2px)',
//                 boxShadow: '0 12px 35px rgba(25, 118, 210, 0.4)',
//               }
//             }}
//           >
//             {t("exploreAllCases")}
//           </Button>
//         </Box>
//       </Fade>

//       {/* Global styles for animations */}
//       <style jsx global>{`
//         @keyframes float {
//           0%, 100% { transform: translateY(0px) rotate(0deg); }
//           50% { transform: translateY(-10px) rotate(180deg); }
//         }
        
//         @keyframes bounce {
//           0%, 100% { transform: translateY(0); }
//           50% { transform: translateY(-5px); }
//         }
//       `}</style>


//        {/* ✅ Modal - Opens on eye icon click */}
//             <AFEViewModal
//               open={viewModalOpen}
//               onClose={handleCloseModal}
//               selectedItem={selectedItem}
//               modalLoading={modalLoading}
//               formatList={formatList}
//             />

//       {/* Snackbar */}
//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };
import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  Box,
  Button,
  Typography,
  Card,
  CardContent,
  IconButton,
  Fade,
  Grow,
  Slide,
  useTheme,
  useMediaQuery
} from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import GavelIcon from "@mui/icons-material/Gavel";
import ExploreIcon from "@mui/icons-material/Explore";
import { API_BASE_URL } from "../../config";
import { LoadingSpinner } from "../../Components/spinner/spinner";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import i18next from "i18next";
import { AFEViewModal } from "../HomePages/assignedFEModal";


export const Case = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const scrollContainerRef = useRef(null);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [autoScroll, setAutoScroll] = useState(true);
  const [visibleCards, setVisibleCards] = useState(new Set());

  // Snackbar state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");

  // ✅ Modal state
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);

  // Fetch cases with language dependency
  const fetchCases = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/home-notification/assignedfe/`,
        { params: { language: i18n.language } }
      );
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        setCases(data);
      } else {
        setCases([]);
      }
    } catch (error) {
      console.error("Error fetching cases:", error);
      setCases([]);
      setSnackbarMessage("Failed to load cases");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  }, [i18n.language]);

  useEffect(() => {
    fetchCases();
  }, [fetchCases]);

  // Auto-scroll functionality
  useEffect(() => {
    if (!autoScroll || cases.length === 0 || loading) return;

    const interval = setInterval(() => {
      if (scrollContainerRef.current) {
        const container = scrollContainerRef.current;
        const scrollWidth = container.scrollWidth;
        const clientWidth = container.clientWidth;
        const currentScroll = container.scrollLeft;

        if (currentScroll + clientWidth >= scrollWidth - 10) {
          container.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          container.scrollBy({ left: 250, behavior: "smooth" });
        }
      }
    }, 2500);

    return () => clearInterval(interval);
  }, [autoScroll, cases.length, loading]);

  // Intersection Observer for card animations
  useEffect(() => {
    if (!scrollContainerRef.current || cases.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleCards((prev) => new Set(prev).add(entry.target.dataset.index));
          }
        });
      },
      {
        root: scrollContainerRef.current,
        threshold: 0.3,
        rootMargin: "50px",
      }
    );

    const cards = scrollContainerRef.current.querySelectorAll(".case-card");
    cards.forEach((card, index) => {
      card.dataset.index = index;
      observer.observe(card);
    });

    return () => observer.disconnect();
  }, [cases]);

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const handleContainerHover = (isHovering) => {
    setAutoScroll(!isHovering);
  };

  // ✅ Handle modal open on card click, fetch full details if necessary
  const openModalWithDetails = async (item) => {
    setModalLoading(true);
    try {
      // Fetch complete details if needed, else pass item directly
      // Assuming API call needed here:
      const response = await axios.get(
        `${API_BASE_URL}/home-notification/assignedfe/${item.id}/`,
        { params: { language: i18n.language } }
      );
      setSelectedItem(response.data);
    } catch (error) {
      console.error("Failed to fetch detailed data:", error);
      setSelectedItem(item); // fallback to item info
      setSnackbarMessage("Failed to load details");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setModalLoading(false);
      setViewModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setViewModalOpen(false);
    setSelectedItem(null);
  };

  const formatList = (text) => {
    if (!text) return "-";
    return text
      .split(/[\d]\.\s+/)
      .filter((item) => item.trim())
      .map((item, index) => `${index + 1}. ${item.trim()}`)
      .join("\n");
  };

  if (loading && cases.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }}>
        <LoadingSpinner size={40} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 4 },
        background: "linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%)",
        borderRadius: 4,
        mx: { xs: 1, sm: 2 },
        mt: 2,
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: -50,
          right: -50,
          width: 100,
          height: 100,
          borderRadius: "50%",
          background: "rgba(66, 133, 244, 0.1)",
          animation: "float 8s ease-in-out infinite",
        },
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: -30,
          left: "10%",
          width: 60,
          height: 60,
          borderRadius: "50%",
          background: "rgba(234, 67, 53, 0.08)",
          animation: "float 6s ease-in-out infinite 2s",
        },
      }}
    >
      {/* Centered Heading with Icon */}
      <Fade in={!loading} timeout={800}>
        <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4 } }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2, mb: 1 }}>
            <GavelIcon
              sx={{
                fontSize: { xs: 32, sm: 40 },
                color: "primary.main",
                animation: "bounce 2s ease-in-out infinite",
              }}
            />
            <Typography
              variant="h4"
              fontWeight="bold"
              sx={{
                fontSize: { xs: "1.5rem", sm: "2rem" },
                background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {t("currentCases")}
            </Typography>
          </Box>
          <Typography variant="body1" color="text.secondary" sx={{ fontSize: { xs: "0.9rem", sm: "1.1rem" } }}>
            Browse through ongoing financial establishment cases
          </Typography>
        </Box>
      </Fade>

      <Box sx={{ display: "flex", alignItems: "center", position: "relative" }}>
        {/* Left Scroll Button */}
        <Slide direction="right" in={!loading} timeout={500}>
          <IconButton
            onClick={scrollLeft}
            aria-label={t("scrollLeft")}
            sx={{
              color: "white",
              fontWeight: "bold",
              fontSize: { xs: 20, sm: 28 },
              background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
              border: "2px solid",
              borderColor: "primary.main",
              "&:hover": {
                background: "linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)",
                transform: "scale(1.1)",
              },
              mr: { xs: 1, sm: 2 },
              p: { xs: 1, sm: 1.5 },
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              boxShadow: "0 4px 15px rgba(25, 118, 210, 0.3)",
              zIndex: 2,
            }}
          >
            <ChevronLeftIcon fontSize="inherit" />
          </IconButton>
        </Slide>

        {/* Scrollable Cards Container */}
        <Box
          ref={scrollContainerRef}
          onMouseEnter={() => handleContainerHover(true)}
          onMouseLeave={() => handleContainerHover(false)}
          sx={{
            display: "flex",
            overflowX: "auto",
            scrollBehavior: "smooth",
            gap: { xs: 2, sm: 3 },
            flexGrow: 1,
            "&::-webkit-scrollbar": {
              height: 6,
            },
            "&::-webkit-scrollbar-track": {
              background: "rgba(0,0,0,0.1)",
              borderRadius: 3,
            },
            "&::-webkit-scrollbar-thumb": {
              background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
              borderRadius: 3,
            },
            scrollbarWidth: "thin",
            minHeight: "160px",
            justifyContent: cases.length === 0 ? "center" : "flex-start",
            alignItems: "center",
            py: 2,
            px: 1,
          }}
          tabIndex={0}
          aria-label={t("casesScrollContainer")}
        >
          {loading && cases.length === 0 ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <LoadingSpinner size={40} color="primary" />
              <Typography variant="body1" color="text.secondary">
                Loading cases...
              </Typography>
            </Box>
          ) : cases.length === 0 ? (
            <Fade in={!loading} timeout={800}>
              <Box sx={{ textAlign: "center", py: 4 }}>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  sx={{
                    fontWeight: "bold",
                    color: "#666",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <span style={{ fontSize: "1.5rem" }}>📭</span>
                  No Cases Available
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  Check back later for new cases
                </Typography>
              </Box>
            </Fade>
          ) : (
            cases.map((item, index) => (
              <Grow
                in={visibleCards.has(index.toString())}
                timeout={800 + index * 100}
                key={item.id || index}
              >
                <Card
                  className="case-card"
                  sx={{
                    minWidth: { xs: 200, sm: 240 },
                    flexShrink: 0,
                    cursor: "pointer",
                    background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                    border: "2px solid transparent",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                    transform: "translateY(0)",
                    mb: 1,
                    ml: 1,
                    position: "relative",
                    overflow: "hidden",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      height: "4px",
                      background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                      transform: "scaleX(0)",
                      transition: "transform 0.3s ease",
                    },
                    "&:hover": {
                      transform: "translateY(-8px) scale(1.02)",
                      boxShadow: "0 15px 40px rgba(25, 118, 210, 0.25)",
                      borderColor: "primary.main",
                      "&::before": {
                        transform: "scaleX(1)",
                      },
                    },
                  }}
                  onClick={() => openModalWithDetails(item)} // ✅ Open modal on card click
                  role="button"
                  tabIndex={0}
                  aria-label={`${t("case")}: ${item.name_of_fe}`}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      openModalWithDetails(item);
                    }
                  }}
                >
                  <CardContent sx={{ p: 3, textAlign: "center", width: "100%" }}>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      noWrap
                      sx={{
                        fontSize: { xs: "1rem", sm: "1.1rem" },
                        color: "#333",
                        lineHeight: 1.3,
                        mb: 1,
                      }}
                    >
                      {item.name_of_fe}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        fontSize: "0.8rem",
                        opacity: 0.8,
                      }}
                    >
                      Click to view details
                    </Typography>
                  </CardContent>
                </Card>
              </Grow>
            ))
          )}
        </Box>

        {/* Right Scroll Button */}
        <Slide direction="left" in={!loading} timeout={500}>
          <IconButton
            onClick={scrollRight}
            aria-label={t("scrollRight")}
            sx={{
              color: "white",
              fontWeight: "bold",
              fontSize: { xs: 20, sm: 28 },
              background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
              border: "2px solid",
              borderColor: "primary.main",
              "&:hover": {
                background: "linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)",
                transform: "scale(1.1)",
              },
              ml: { xs: 1, sm: 2 },
              p: { xs: 1, sm: 1.5 },
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              boxShadow: "0 4px 15px rgba(25, 118, 210, 0.3)",
              zIndex: 2,
            }}
          >
            <ChevronRightIcon fontSize="inherit" />
          </IconButton>
        </Slide>
      </Box>

      {/* Explore All Cases Button */}
      <Fade in={!loading} timeout={1000}>
        <Box mt={4} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/ca/authority/assingnedfe"
            startIcon={<ExploreIcon />}
            sx={{
              minWidth: { xs: 180, sm: 220 },
              fontSize: { xs: "0.9rem", sm: "1rem" },
              px: { xs: 3, sm: 4 },
              py: { xs: 1.2, sm: 1.5 },
              background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
              borderRadius: 3,
              fontWeight: "bold",
              textTransform: "none",
              boxShadow: "0 8px 25px rgba(25, 118, 210, 0.3)",
              transition: "all 0.3s ease",
              "&:hover": {
                background: "linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)",
                transform: "translateY(-2px)",
                boxShadow: "0 12px 35px rgba(25, 118, 210, 0.4)",
              },
            }}
          >
            {t("exploreAllCases")}
          </Button>
        </Box>
      </Fade>

      {/* Global styles for animations */}
      <style jsx global>{`
        @keyframes float {
          0%,
          100% {
            transform: translateY(0px) rotate(0deg);
          }
          50% {
            transform: translateY(-10px) rotate(180deg);
          }
        }

        @keyframes bounce {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-5px);
          }
        }
      `}</style>

      {/* ✅ Modal Component */}
      <AFEViewModal
        open={viewModalOpen}
        onClose={handleCloseModal}
        selectedItem={selectedItem}
        modalLoading={modalLoading}
        formatList={formatList}
      />

      {/* Snackbar */}
      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
